import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import Form from 'antd/es/form';
import React from 'react';
import { StakeholderType } from '@sonar-software/sonar-core';
import { Radio, Space } from 'antd';

export interface StakeholderTypeOptionProps {
	disabled?: boolean;
	id?: string;
	label?: string;
	name?: string;
}

export const StakeholderTypeOption: React.FC<StakeholderTypeOptionProps> = ({ disabled, id, label, name = 'type' }) =>
	<Form.Item
		id={ id }
		label={ label }
		name={ name }>
		<Radio.Group disabled={ disabled }>
			<Space direction='vertical'>
				<Radio value={ StakeholderType.Individual }>{ COPY_SPECIFIC.INDIVIDUAL }</Radio>
				<Radio value={ StakeholderType.Team }>{ COPY_SPECIFIC.TEAM }</Radio>
			</Space>
		</Radio.Group>
	</Form.Item>;

